class DetailsNavigation extends HTMLElement {
    constructor() {
        super()
        this.mainDetailsToggle = this.querySelector('details');
        this.mainSummary = this.querySelector('summary');

        this.addEventListener('keyup', window.onKeyUpEscape);
        this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        document.addEventListener('click', this.onClickAway.bind(this));
    }

    onMouseEnter(event) {
        this.open();
    }

    onMouseLeave(event) {
        this.close();
    }

    onClickAway(event) {
        if (!this.contains(event.target)) this.close();
    }

    open() {
        this.mainDetailsToggle.setAttribute('open', 'open');
        requestAnimationFrame(() => {
            this.mainDetailsToggle.classList.add('open');
        })
    }

    close() {
        this.mainDetailsToggle.classList.remove('open');
        this.mainDetailsToggle.removeAttribute('open');
    }
}

customElements.define('details-navigation', DetailsNavigation);